import 'css-chunksrc/client/scenes/wbs/preview/styles.scss';export default {
  "preview": "_preview_1gyko_1",
  "icon": "_icon_1gyko_9",
  "list": "_list_1gyko_19"
};